/**
 * Why the retainer payout can't be requested, for when the API sends only
 * `cannot_request_reason` and no `cannot_request_message` to show.
 */
export const CANNOT_REQUEST = {
  not_retainer: 'You are not a retainer affiliate.',
  no_affiliate_code: 'You need an affiliate code before you can request a retainer payout.',
  no_retainer_cost: 'Your retainer amount has not been set yet.',
  no_payout_day: 'Your retainer payout day has not been set yet.',
  already_requested: "You've already requested this cycle's payout.",
  window_closed: 'Requests open on your payout day.',
  payment_not_verified: 'Verify your payment details before requesting a payout.',
};

/** The three chips. A payout's own status ("New", "Paid", …) falls into one of them. */
export const PAYOUT_GROUPS = [
  { label: 'Approved', tone: 'success' },
  { label: 'In Progress', tone: 'info' },
  { label: 'Rejected', tone: 'danger' },
];

/** "New" / "Processing" are in progress; "Approved" / "Paid" are approved. */
export const payoutGroup = (status) => {
  const s = String(status ?? '').trim().toLowerCase();
  if (['approved', 'paid', 'completed', 'success'].includes(s)) return 'Approved';
  if (['rejected', 'declined', 'cancelled', 'canceled', 'failed'].includes(s)) return 'Rejected';
  return 'In Progress';
};
